import { render, staticRenderFns } from "./NewConsignmentCaptureForm.vue?vue&type=template&id=55fd72de&scoped=true"
import script from "./NewConsignmentCaptureForm.vue?vue&type=script&lang=js"
export * from "./NewConsignmentCaptureForm.vue?vue&type=script&lang=js"
import style0 from "./NewConsignmentCaptureForm.vue?vue&type=style&index=0&id=55fd72de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fd72de",
  null
  
)

export default component.exports